import { render, staticRenderFns } from "./Decision.vue?vue&type=template&id=57b794f8&scoped=true&"
import script from "./Decision.vue?vue&type=script&lang=js&"
export * from "./Decision.vue?vue&type=script&lang=js&"
import style0 from "./Decision.vue?vue&type=style&index=0&id=57b794f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b794f8",
  null
  
)

export default component.exports